import React, { Component } from 'react';

import queryString from "query-string";

import { withRouter } from 'react-router';

import { Formik, Form } from 'formik';

import { MigrateStudentsApi } from "../../util/api/ServiceObjects/MigrateStudentsApi";
import { StudentApi } from "../../util/api/StudentApi";

import { Alert } from "../../store/Alert";


import { observer } from 'mobx-react';

class StudentMigration extends Component {
    static displayName = StudentMigration.name;

    constructor(props) {
        super(props);

        let params = queryString.parse(props.location.search)

        this.state = {
            loading: true,
        };

        this.editAccount = this.editAccount.bind(this);
        this.editStudent = this.editStudent.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);

        this.uploadCSV = this.uploadCSV.bind(this);

        this.props.store.updateBanner("Migrate Students");
    }

    editStudent(e) {
        const studentId = e.target.value;
        console.log(studentId)

        this.props.history.push("/staff/Student/" + studentId);
    }

    async deleteStudent(e) {
        console.log(e.target.value)
        if(window.confirm( "Are you sure you'd like to remove this student from SWS?" )) {
            const studentId = e.target.value;
            console.log(e)

            await StudentApi.delete(studentId);
            
            await this.props.store.getFromApi(["students"])

            let successAlert = new Alert("Successfully deleted student");
            this.props.store.addAlert(successAlert);

        }
    }

    editAccount(e) {
        const accountId = e.target.value;
        this.props.history.push("/staff/Account/" + accountId);
    }

    async uploadCSV(csvFile) {
        console.log(csvFile);
        try {
            let response = await MigrateStudentsApi.upload(csvFile);

            console.log(response); 

            //show success alert.
            let successAlert = new Alert("Successfully migrated students", response, "sucess");
            this.props.store.addAlert(successAlert);

            await this.props.store.getFromApi(["students"])

        }
        catch (error) {
            console.log(error)

            if(error.response) {
                let alert = new Alert("An error occurred", error.response.data.title);
                this.props.store.addAlert(alert);
            }
            else {
                let alert = new Alert("Network Error", error.message);
                this.props.store.addAlert(alert);
            }
        }
    }

    render() {

        //Find all students with an award amound of zero or that haven't yet been migrated. 
        const unmigratedStudents = this.props.store.students.collection.filter((student) => {
            if (student.awardAmount <= 0 || student.accountIds.length === 0) {
                return true;
            }
            return false;
        });

        return (
            <div>
                <div className="row">

                    <Formik 
                        onSubmit={(values) => {
                            console.log(values)
                        }}
                        initialValues={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                        validate={values => {}}
                    >
                        <Form>
                            <h2>Import Students</h2>
                            <label className="mt-2" for="file">
                                To migrate students exported from the Finacial Aid application app, please upload the .csv file. 
                            </label>
                            <br></br>

                            <input className="mt-2" id="file" name="file" type="file" onChange={(event) => {
                                this.uploadCSV(event.currentTarget.files[0]);
                            }} />
                        </Form>
                    </Formik>
                </div>
                <div className="row">
                    <table className="w-100 table-hover">
                    <thead>
                        <tr>
                            
                            <th scope="col">Student Name</th>

                            <th style={{width: "30%"}} scope="col">Pending Steps</th>

                            <th scope="col">Edit Student</th>

                            <th scope="col">Create / Edit Account</th>
   
                        </tr>
                    </thead>
                    <tbody>
                        {unmigratedStudents.map((student, i) =>
                            <tr key={"student-migration-" + i}>
                                    <td >
                                        {student.name}
                                    </td>
                                    <td style={{ width: "30%"} }>
                                        <ul>
                                            {student.awardAmount <= 0 && 
                                                <li>Student must be assigned an award amount.</li>
                                            }
                                            {student.accountIds.length === 0 && 
                                                <li>There is no account is associated with this student.</li>
                                            }
                                        </ul>
                                    </td>
                                    <td>
                                        <button value={student.id} onClick={this.editStudent} className="btn btn-secondary">Edit Student</button>
                                        <button value={student.id} onClick={this.deleteStudent} className="btn btn-light mt-1">Delete Student</button>
                                    </td>
                                    <td>
                                        {student.accountIds.length === 0 ? 
                                            (<button onClick={this.editAccount} className="btn btn-primary">Create Account</button>)
                                            :
                                            (
                                                <React.Fragment>
                                                    <p>Associated account(s):</p>
                                                    {student.accountIds.map((accountId, j) => 
                                                        <button value={accountId} onClick={this.editAccount} className="btn btn-secondary mb-1">
                                                            {"Account " + j}
                                                        </button>
                                                    )}
                                                </React.Fragment>
                                            )
                                        }
                                    </td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

StudentMigration = withRouter(observer(StudentMigration));

export {StudentMigration};